<template>
    <div class="ucenter">
        <header class='ucenter_header'>
            <div class="ucenter_header_t">
                <div class="ucenter_header_l">
                    <img :src='userInfo.avatar' alt="" class="avatar">
                </div>
                <div class="ucenter_header_r">
                    <h3 class="user_name">{{userInfo.nickname}}</h3>
                    <h3 class="my_follow" @click.stop.prevent="downApp">我的关注&nbsp;&nbsp;<span>{{follow_num}} </span></h3>
                </div>
            </div>

            <div class="ucenter_header_b">
                <div class="ucenter_header_b_fix">
                    <button class="my-buy btn" @click.stop.prevent="jumpTo('mybuy')">我的购买</button>
                    <button class="to-mes btn" @click.stop.prevent="jumpTo('mes')">联系客服</button>
                </div>
            </div>
        </header>

        <!-- 中间body主体 -->
        <div class="bd">
            <div class="cellbox-warp">
                <a :href='userInfo.l_id==0 ? "/ucenter/user_home/m_u_id/"+userInfo.id+".html":"/lives/center/id/"+userInfo.l_id+".html"' class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-home"></i> 
                        <div class="cell-title">                          
                            <span>我的主页</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
                <a href="/ucenter/user_info_modify" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-userinfo"></i> 
                        <div class="cell-title">                          
                            <span>个人资料</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
                <a href="/index/statement.html" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-statement"></i> 
                        <div class="cell-title no-border">                          
                            <span>免责声明</span>                          
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="ft">
            <!-- 退出登录 -->
            <a href="/login/loging_out" class="login_out">退出</a>
        </div>
    </div>
</template>

<script>

// import UserProfilesApi from '@/api/userProfiles/';
import ucenterApi from '@/api/mine/ucenter';
import * as NumApi from "@/api/userNum/index.js";

export default {
    name: 'ucenter',
    components: {

    },
    data() {
        return {
           userInfo: {}, 
           user_id: parseInt(this.$route.params.id),
           follow_num: 0
        };
    },
    created() {
        this.getUser()
    },
    methods: {
        getNum() {
            NumApi.user({
                params:{
                    u_id:this.userInfo.id,
                }
            })
            .then(res => {
                let data = res.data.info;
                if(data && data.follow_num) {
                    this.follow_num = data.follow_num;
                }
            })
            .catch(err=>{
                console.log(err)
            })
            return
            NumApi.teacher({
                params:params
            })
            .then(res => {
                let data = res.data;
                console.info(data,'dataINFO')
            })
            .catch(err=>{
                console.log(err)
            })
        },
        downApp() {
            this.$downapppop.open();
        },    
        jumpTo(type) {
            let originName = location.origin
            if(originName.indexOf("jfinfo.com") > -1) {
                if(type == "mybuy") {
                    location.href =  "/up/mybuy"
                } else if(type == "mes") {
                    location.href =  "/up/mes/108388"
                }   
            } else {
                this.$downapppop.open('查看')
            }
        },
        //获取个人信息
        async getUser() {
            // let data = await ucenterApi.getUserInfo(); 
            let data = await ucenterApi.getUserInfo_normal(); 
            if(location.origin.indexOf("192.168.1") > -1) {
                data = {
                    "id": "44324",
                    "invited_id": "0",
                    "l_id": "46",
                    "manage": "admin",
                    "gold": "15",
                    "gold_give": "2562",
                    "type": "igp",
                    "username": "cszh",
                    "email": "qirx@aigupiao.com",
                    "phone_in_agreement": null,
                    "wx": "",
                    "avatar": "https:\/\/img1-cdn-picsh.aigupiao.com\/user\/avatar\/2025-12-03\/daa554e24c401d76cdae2b8d3ce22ed5.jpg",
                    "nickname": "\u5c0f\u97ed\u83dc2026",
                    "brief": "\u5927\u54e5\u5927",
                    "stock_list": "BK01219,HK02331,HK00981,USORCL,USPDD,sh601166,sz300552,sh603122,BK00295,BK01327,BK01435",
                    "futures_list": "",
                    "note": "",
                    "rec_time": "2016-01-26 13:07:57",
                    "up_time": "2017-05-04 11:30:24",
                    "rec_ip": "124.72.237.255",
                    "state": "",
                    "platform": "",
                    "add_v": "0",
                    "add_v_time": "0",
                    "add_v_dec": "",
                    "login_status": "74aa28e7a93262c9bbb0d7089582c7f2",
                    "device_uid": "",
                    "stock_show": "yes",
                    "open_times": "302303",
                    "last_time": "2025-12-30 09:14:05",
                    "is_skip_label": "0",
                    "login_times": "15910",
                    "last_login_time": "2025-12-30 09:10:03",
                    "install_cnl": "",
                    "curr_cnl": "Channel_360",
                    "level": "15",
                    "level_reward": "10",
                    "experience": "17945",
                    "next_experience_differ": "9982054",
                    "guess_v": "no",
                    "view_self": "no",
                    "app_version": "1270",
                    "update_time": "2025-12-30 09:14:05",
                    "server_qa": "0",
                    "server_qa_gold": "15",
                    "home_page_view_range": "HalfYear",
                    "all_show": "0",
                    "stock_ring_user": "0",
                    "cms_set_stock_show": "1",
                    "theme_list": "19,204,191,231",
                    "promotion_channel": "",
                    "label": "no",
                    "allow_reward": "no",
                    "is_bind_phone": "yes",
                    "user_app_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjQ0MzI0IiwiZXhwIjoxNzY3MjU0MzI3LCJpc3MiOiJpZ3AiLCJzdWIiOiI0NDMyNCJ9.a8ebv9VqIG6ZpqmtlHTR4ta9s55E2RXIssAB7ju1_pA",
                    "is_self": "yes",
                    "total_gold": "2577"
                }
            }
            this.userInfo = data;
            if(data && Object.keys(data).length > 0) {
                this.getNum();
            }
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" >
body{
    background-color: #F0F0F0;
}

.ucenter{padding-bottom: 63px;}
.indexicon{
    display: inline-block;
    width: 19px;
    height: 19px;    
    vertical-align: middle;
    margin: 18px 10px 0 0 ;
}
.icon-home{
    background:url(../../assets/images/icon-userhome.png) no-repeat;
    background-size:cover;
}
.icon-userinfo{
    background:url(../../assets/images/icon-userinfo.png) no-repeat;
    background-size:cover;
}
.icon-statement{
    background:url(../../assets/images/icon-disclaimer@2x.png) no-repeat;
    background-size:cover; 
}
.cellbox{
    background-color: #fff;
    box-sizing: border-box;
    color: inherit;
    min-height: 54px;
   
    display: block;
    overflow: hidden;
    position: relative;
    text-decoration: none;
    .cell-wrapper {             
        box-sizing: border-box;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 16px; 
        min-height: inherit;
        overflow: hidden;
        padding: 0 0 0 14px;
        width: 100%;
    }
    .cell-title {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        height: 54px;
        line-height: 54px;
        border-bottom:1px solid #EBEBEB;
    }
    .cell-allow-right{
        top: 20px;
        right: 20px;
        position: absolute;
        display: inline-block;
        background: url(../../assets/images/icon-right-gray@2x.png) no-repeat;
        background-size: 100% 100%;
        width: 9px;
        height: 14px;
    }
    .tips{
        top: 0px;
        right: 30px;
        position: absolute;
        color: #939393;
        font-size: 15px
    }
    .no-border{
        border:none;
    }   
}

.ucenter_header{
    width: 100%;
    height: 160px;
    background: linear-gradient(180deg, #F5E3D4 0%, rgba(245, 227, 212, 0) 100%);
    position: relative;
    padding: 30px 16px;
    box-sizing: border-box;
    margin-bottom: 32px;

    .ucenter_header_t {
        display: flex;
        flex-direction: row;

        .ucenter_header_l {
            .avatar{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                border: 2px solid rgba(255, 255, 255, 0.8);
                margin-left: 6px;
            }
        }
    
        .ucenter_header_r {
            padding-left: 18px;
            box-sizing: border-box;
    
            .user_name{
                font-size: 18px;
                line-height: 25px;
                font-weight: 600;
                margin: 2px 0 10px 0;
                color: #333;
            }
    
            .my_follow {
                font-size: 15px;
                line-height: 21px;
                color: #636363;
                font-weight: 400;
    
                span {
                    font-weight: 500;
                }
            }
        }
    }

    .ucenter_header_b {
        margin-top: 30px;
        position: relative;

        .ucenter_header_b_fix {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            width: 100%;
            z-index: 2;

            .btn {
                width: 100%;
                height: 56px;
                line-height: 56px;
                border-radius: 8px;
                background-color: #fff;
                border: none;
                outline: none;
                text-align: left;
                padding: 0 0 0 12px;
                color: #333;
                font-size: 15px;
                font-weight: 400;
                background-size: 36px;
                background-repeat: no-repeat;
                background-position: right 16px center;
                cursor: pointer;
    
                &:last-of-type {
                    margin-left: 10px;
                }
            }
    
            .my-buy {
                background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/my_buy_icon.svg");
            }
    
            .to-mes {
                background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/direct_msg_user_icon.svg");
            }
        }
    }
}

.bd {
    width: clac(100% - 16px);
    height: auto;
    margin: 0 16px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow: hidden;

    .cellbox-warp{
        background-color: #fff;
    }
}

.ft {
    width: clac(100% - 16px);
    height: auto;
    margin: 12px 16px 0;

    a {
        width: 100%;
        height: 45px;
        background-color: #fff;
        border-radius: 8px;
        font-size: 16px;
        line-height: 45px;
        color: #333;
        display: block;
        text-align: center;
    }
}

</style>